import React from "react";
import styles from "../css/fix-benefits.black-and-blue.module.scss";
import classNames from "classnames";
import { FixLink } from "@/elements-react/fix-link";
import afterCareImg from "@/assets/aftercare.webp";
import repairExpertiseImg from "@/assets/repairexpertise.webp";
import documentationImg from "@/assets/documentation.webp";
import qualityControlImg from "@/assets/qualitycontrol.webp";
import { Icon } from "@/elements-react/fix-icon";
import { useTranslation } from "react-i18next";
import {FixBenefitsProps} from "@/elements-react/fix-benefits";
import {Url} from "@/helpers/url.ts";

export const FixBenefitsBlackAndBlue: React.FC<FixBenefitsProps> = (props: FixBenefitsProps) => {
    const { t } = useTranslation();

    const items = [
        {
            image: afterCareImg,
            title: t("why_choose_us.after_sales_care.title", "After-sales care"),
            description: t("why_choose_us.after_sales_care.description", "We stay in touch to assist with installation, warranty or replacements")
        },
        {
            image: repairExpertiseImg,
            title: t("why_choose_us.repair_expertise.title", "Repair expertise"),
            description: t("why_choose_us.repair_expertise.description", "Our experience comes from repairing car, trucks, buses and vans every day")
        },
        {
            image: documentationImg,
            title: t("why_choose_us.service_documentation.title", "Service documentation"),
            description: t("why_choose_us.service_documentation.description", "Get official service instructions and repair manuals for your mechanics")
        },
        {
            image: qualityControlImg,
            title: t("why_choose_us.quality_control.title", "Quality control"),
            description: t("why_choose_us.quality_control.description", "Every order checked before shipping to ensure quality and accuracy")
        }
    ];

    return (
        <div className={classNames(styles.container, props.className)}>
            <div className={styles.heading}>
                <h2 className={styles.title}>{t("why_choose_us.title", "Why choose us")}</h2>
                <div className={styles.subtitle}>{t("why_choose_us.subtitle", "Expertise you can rely on")}</div>
            </div>

            <div className={styles.grid}>
                {items.map((item, index) => (
                    <div key={index} className={styles.card}>
                        <img src={item.image} alt={item.title} className={styles.cardImage} />
                        <div className={styles.cardContent}>
                            <h3 className={styles.cardTitle}>{item.title}</h3>
                            <p className={styles.cardDescription}>{item.description}</p>
                        </div>
                    </div>
                ))}
            </div>

            <FixLink href={Url.to("about-us-page")}  className={styles.link}>
                <span className={styles.label}>{t("footer.about_us", "About us")} <Icon name='arrow-right' /></span>
            </FixLink>
        </div>
    );
};
